import { useAnalytics } from '@/app/context/AnalyticsContext/useAnalytics';
import { useCustomer } from '@/app/context/CustomerContext/useCustomer';
import { useDeck } from '@/app/context/DeckContext/useDeck';
import { useModal } from '@/app/context/ModalContext/useModal';
import { ProFeatureKey } from '@/components/common/modal/upgrade/Upgrade';
import Link from 'next/link';
import { ChangeEventHandler, useEffect, useState } from 'react';

export const LearningObjectives = () => {
  const { cacheLearningObjectives, selectedDeckLearningObjectives } = useDeck();
  const { selectedDeck } = useDeck();
  const { isProEligible, isPro } = useCustomer();
  const { openModal } = useModal();
  const { trackEvent, analyticsInstance } = useAnalytics();

  const [didTrackUpgrade, setDidTrackUpgrade] = useState(false);

  const characterLimit = 2000;

  useEffect(() => {
    if (!isPro && isProEligible && !didTrackUpgrade) {
      setDidTrackUpgrade(true);
      trackEvent(analyticsInstance, 'upgrade_visible', {
        upgrade_source: 'learning_objectives'
      });
    }
  }, [isPro, isProEligible]);

  const onChange = (e) => {
    if (selectedDeck?.id && isPro) {
      if (e.target && e.target.value) {
        const limitedString = e.target.value.substring(0, characterLimit);
        cacheLearningObjectives(selectedDeck.id, limitedString);
      } else {
        cacheLearningObjectives(selectedDeck.id, '');
      }
    }
  };

  return (
    <div
      style={{ height: 'calc(100% - 132px)' }}
      className="mt-24 flex flex-col gap-8 pb-8 pl-12 pr-12 lg:mt-12"
    >
      <label className="form-control relative h-full">
        {!isPro && (
          <div className="absolute flex w-full items-center justify-center">
            <button
              onClick={() => {
                trackEvent(analyticsInstance, 'upgrade_click', {
                  upgrade_source: 'learning_objectives'
                });

                trackEvent(
                  analyticsInstance,
                  'learning_objectives_click_upgrade',
                  {
                    deck_id: selectedDeck.id
                  }
                );

                openModal('upgrade', 'learningObjectives' as ProFeatureKey);
              }}
              className="btn btn-primary mt-24"
            >
              Upgrade to Limbiks Pro
            </button>
          </div>
        )}

        <textarea
          style={{ lineHeight: 1.3 }}
          disabled={!isPro}
          className="textarea-sm textarea textarea-bordered h-full bg-base-300 text-base-content"
          placeholder={`Enter your learning objectives here...
               
Limbiks wiill ignore flashcards that are not related to your learning objectives
          
Here is a set of example learning objectives...

Understand the Structure of Mitochondria: Identify the different parts of a mitochondrion and describe their functions. This includes the outer membrane, inner membrane, cristae, and matrix.

Explain the Role of Mitochondria in Energy Production: Describe the process of oxidative phosphorylation and how the mitochondria produces ATP in the process.

Discuss the Mitochondrial DNA (mtDNA): Understand the unique characteristics of mitochondrial DNA, its role in heredity, and its implications in certain genetic disorders.`}
          value={selectedDeckLearningObjectives ?? ''}
          onChange={onChange}
        ></textarea>
        <div className="label">
          <span className="label-text-alt">
            <div className="badge badge-outline">Pro Feature</div>
            {isPro && (
              <span
                className="link ml-3"
                onClick={() => {
                  trackEvent(
                    analyticsInstance,
                    'learning_objectives_click_feedback',
                    {
                      deck_id: selectedDeck.id
                    }
                  );
                  openModal('feedback');
                }}
              >
                Give Feedback
              </span>
            )}
          </span>
          <span className={`label-text-alt`}>
            {(selectedDeckLearningObjectives ?? '').length}/{characterLimit}
          </span>
        </div>
      </label>
    </div>
  );
};
